import { TicketFilter } from '@shared/models/help-ticket.model';
import { FilterInputType, InputProps, InputPropOption } from '../filters-bar/input-props';
import moment from 'moment';

export const DEFAULT_TICKET_FILTERS_CONFIG = {
  statusId: [],
  date: null,
  hasAttachments: null,
  createdBy: [],
  assignedTo: [],
  country: [],
  lob: [],
} as any as TicketFilter;

export const FILTER_EMPTY_VALUE: InputPropOption & { code?: string } = {
  key: null,
  value: null,
  name: '--',
  actualValue: null,
  code: '--',
};

export const FILTERS: InputProps[] = [
  {
    type: FilterInputType.MultiSelect,
    placeholder: 'All',
    allKey: 'All',
    field: 'statusId',
    label: 'shared.status',
    value: '',
    options: [],
  },
  {
    type: FilterInputType.Select,
    field: 'date',
    label: 'shared.daysOpen',
    value: '',
    options: [
      FILTER_EMPTY_VALUE,
      {
        value: 'shared.lessThanSixDays',
        actualValue: {
          gte: moment().subtract(6, 'd').format('YYYY-MM-DD'),
        },
        key: '01',
      },
      {
        value: 'shared.lessThanThirtyDays',
        actualValue: {
          gte: moment().subtract(30, 'd').format('YYYY-MM-DD'),
        },
        key: '02',
      },
      {
        value: 'shared.greaterThanThirtyDays',
        actualValue: {
          lte: moment().subtract(30, 'd').format('YYYY-MM-DD'),
        },
        key: '03',
      },
      {
        value: 'shared.greaterThanSixtyDays',
        actualValue: {
          lte: moment().subtract(60, 'd').format('YYYY-MM-DD'),
        },
        key: '04',
      },
    ],
  },
  {
    type: FilterInputType.Select,
    field: 'hasAttachments',
    label: 'shared.withAttachments',
    value: '',
    options: [
      FILTER_EMPTY_VALUE,
      { key: 'Y', value: 'shared.yes', actualValue: true },
      { key: 'N', value: 'shared.no', actualValue: false },
    ],
  },
  {
    type: FilterInputType.MultiSelect,
    placeholder: 'All',
    allKey: 'All',
    field: 'createdBy',
    label: 'shared.createdBy',
    value: '',
    options: [],
  },
  {
    type: FilterInputType.MultiSelect,
    placeholder: 'All',
    allKey: 'All',
    field: 'assignedTo',
    label: 'shared.assignedTo',
    value: '',
    dataKey: '',
    options: [],
  },
  {
    type: FilterInputType.MultiSelect,
    placeholder: 'All',
    allKey: 'All',
    field: 'country',
    label: 'admin.country',
    value: '',
    options: [],
  },
  {
    type: FilterInputType.MultiSelect,
    placeholder: 'All',
    allKey: 'All',
    field: 'lob',
    isTitleCaseRequired: false,
    label: 'admin.lob',
    value: '',
    options: [],
  },
  {
    type: FilterInputType.ClearValues,
    field: 'clearvalues',
    css: 'filter-clear-actions',
  },
  { type: FilterInputType.Separator, field: 'separator', css: 'col-4 reports-divider' },
  {
    type: FilterInputType.SearchBar,
    field: 'searchText',
    placeholder: `core.searchTicket`,
    css: 'reports-search-bar',
    options: [],
  },
];

export const FILTER_FIELDS = {
  profile: ['statusId', 'date', 'hasAttachments', 'assignedTo', 'clearvalues', 'separator', 'searchText'],
  admin: [
    'statusId',
    'date',
    'hasAttachments',
    'createdBy',
    'assignedTo',
    'country',
    'lob',
    'clearvalues',
    'separator',
    'searchText',
  ],
};
